<template>
  <div class="table_box">
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      header-row-class-name="header_table_row"
    >
      <el-table-column prop="workTypeName" label="工单类型" align="center">
      </el-table-column>
      <el-table-column prop="finishedWorkCount" label="数量" align="center">
      </el-table-column>
      <el-table-column prop="abnormalWorkCount" label="异常工单" align="center">
        <template slot-scope="scope">
          <div style="color: red">
            {{ scope.row.abnormalWorkCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="abnormalWorkCount" label="操作" align="center">
        <template slot-scope="scope">
          <div
            style="color: #2d8cf0; cursor: pointer"
            @click="onEditInfo(scope.row)"
          >
            查看
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import detailWorkList from "./detailWorkList.vue";
import detailConsumableList from "./detailConsumableList.vue";
import detailPatrolList from "./detailPatrolList.vue";
import detailFacilityList from "./detailFacilityList.vue";
export default {
  components: {
    detailWorkList,
    detailConsumableList,
    detailPatrolList,
    detailFacilityList,
  },
  data() {
    return {
      query: {
        userId: null,
      },
      tableData: [],
    };
  },
  created() {
    this.query.userId = this.$route.query.kv;
    this.load();
  },
  methods: {
    async load() {
      let q = {};
      q.userId = this.query.userId;
      let res = await $utils.api.load(
        "admin/system/performanceRule/performance/workDetail",
        q,
        "get"
      );
      if (res.code == 200) {
        this.tableData = res.data;
      }
    },
    onEditInfo(row) {
      this.$Modal.success({
        closable: true,
        title: row.workTypeName,
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          console.log(row);

          if (row.workType == "repair") {
            return <detailWorkList detailList={row.works} />;
          } else if (row.workType == "consumable") {
            return <detailConsumableList detailList={row.works} />;
          } else if (row.workType == "patrol") {
            return <detailPatrolList detailList={row.works} />;
          } else if (row.workType == "facility") {
            return <detailFacilityList detailList={row.works} />;
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.table_box {
  /deep/ .header_table_row {
    background: #fafafa;
    color: #515a6e;
    .el-table__cell {
      background: #fafafa;
    }
  }
}
</style>
